import { IncidentDetailPatient } from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';
import { BorderedContainer } from '../../../common/BorderedContainer';
import { convertToPresenceAbsence } from '../../../common/converters';
import { SectionTitle } from '../../../common/SectionTitle';
import { InfoDisplay } from '../../common/InfoDisplay';

type Props = {
  /** 基本情報。 */
  baseInfo: IncidentDetailPatient['baseInfo'];
  /** 要請履歴。 */
  acceptRequestHistory: IncidentDetailPatient['acceptRequestHistory'];
};

/** 基本情報のコンポーネント。 */
export const BaseInfo = ({ baseInfo, acceptRequestHistory }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="基本情報" />
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay title="氏名" content={baseInfo?.name ?? ''} />
          <InfoDisplay title="ふりがな" content={baseInfo?.furigana ?? ''} />
          <InfoDisplay title="性別" content={baseInfo?.sex ?? ''} />
          <InfoDisplay title="生年月日" content={baseInfo?.birthday ?? ''} />
          <InfoDisplay title="年齢" content={baseInfo?.age ?? ''} />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="傷病者住所"
            content={baseInfo?.patientAddress ?? ''}
          />
          <InfoDisplay
            title="傷病者連絡先"
            content={baseInfo?.contactPatient ?? ''}
          />
          <InfoDisplay
            title="傷病者職業"
            content={baseInfo?.occupation ?? ''}
          />
        </div>
        <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
          <InfoDisplay
            title="付き添い"
            content={convertToPresenceAbsence(
              baseInfo?.accompanimentPresence ?? null
            )}
          />
          <InfoDisplay
            title="付き添い者(同乗者)"
            content={baseInfo?.accompanyingPerson ?? ''}
          />
          <InfoDisplay
            title="付き添い者(関係者連絡先)"
            content={baseInfo?.contactPerson ?? ''}
          />
          <InfoDisplay
            title="収容施設"
            content={getDeterminedHospitalName(acceptRequestHistory)}
          />
        </div>
        <InfoDisplay
          title="家族への連絡有無、連絡先、傷病者所持品、引継者"
          content={baseInfo?.familyContact ?? ''}
        />
      </div>
    </BorderedContainer>
  );
};

/** 搬送先が決まった医療機関名を取得する関数。 */
const getDeterminedHospitalName = (
  acceptRequestHistory: IncidentDetailPatient['acceptRequestHistory']
) => {
  if (!acceptRequestHistory || acceptRequestHistory.length === 0) {
    return '';
  }

  // 配列の最後の要素からDESTINATION_DETERMINEDの要素を探す。
  const destinationItem = [...acceptRequestHistory]
    .reverse()
    .find(item => item.requestStatus === 'DESTINATION_DETERMINED');

  return destinationItem?.destinationTarget?.hospitalName ?? '';
};
